import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_TIPOS_DOCUMENTO_ASSINATURA = `${modulo.ASSINATURA}/tiposDocumento`

const actions = {
  async getTiposDocumento ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `${URL_TIPOS_DOCUMENTO_ASSINATURA}`
    })

    return data
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assinatura/tipoDocumentoAssinatura.js